import {PayloadAction, createSlice} from '@reduxjs/toolkit';

interface CreateBrand {
  inputGroupCode: number | null;
  name: string | null;
  logo: File | Blob | string | null;
  createdId: number | null;
}

const initialState: CreateBrand = {
  inputGroupCode: null,
  name: null,
  logo: null,
  createdId: null,
};

export const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    addBrand: (state, action: PayloadAction<CreateBrand>) => {
      state.inputGroupCode = action.payload.inputGroupCode;
      state.name = action.payload.name;
      state.logo = action.payload.logo;
      state.createdId = action.payload.createdId;
    },
    clearBrand: state => {
      state = initialState;
    },
  },
});

export const {addBrand, clearBrand} = brandSlice.actions;
export default brandSlice.reducer;
